/*!

=========================================================
* Material Dashboard PRO React - v1.10.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-pro-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React, { lazy, Suspense } from "react";
import ReactDOM from "react-dom";
import { Router, Route, Switch, Redirect } from "react-router-dom";
import { createBrowserHistory } from "history";
export const history = createBrowserHistory();
import "assets/scss/material-dashboard-pro-react.scss?v=1.10.0";
const LoginPage = lazy(() => import("./views/Pages/LoginPage"));
const ForgotPasswordPage = lazy(() => import("./views/Pages/ForgotPasswordPage"));
const CodeVerificationPage = lazy(() => import("./views/Pages/CodeVerificationPage"));
const ResetPasswordPage = lazy(() => import("./views/Pages/ResetPasswordPage"));
const AdminLayout = lazy(() => import("./layouts/Admin.js"));
import { QueryClientProvider, QueryClient } from "react-query";
import { Backdrop, CircularProgress } from "@material-ui/core";
import './index.css'

const queryClient = new QueryClient();
ReactDOM.render(
  <Suspense fallback={
    <Backdrop style={{
      position: "fixed",
      top: "0px",
      bottom: "0px",
      left: "0px",
      right: "0px",
      backgroundColor: "rgba(0,0,0,0.5)",
      zIndex: 10000,
    }} open={true} >
        <CircularProgress color="primary" />
      </Backdrop>
  }>
    <Router history={history}>
      <QueryClientProvider client={queryClient}>
        <Switch>
          <Route path="/admin" component={AdminLayout} />
          <Route path="/forgotpassword" component={ForgotPasswordPage} />
          <Route path="/verifycode" component={CodeVerificationPage} />
          <Route path="/resetpassword" component={ResetPasswordPage} />
          <Route path="/login" component={LoginPage} />
          <Redirect from="/" to="/login" />
        </Switch>
      </QueryClientProvider>
    </Router>
  </Suspense>,
  document.getElementById("root")
);
